export var AuditLogMfaMethod;
(function (AuditLogMfaMethod) {
    AuditLogMfaMethod["AuthenticatorApp"] = "AUTHENTICATOR_APP";
})(AuditLogMfaMethod || (AuditLogMfaMethod = {}));
